import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ApdmBuildStep } from '@euler/model/apdm';
import { Check } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../theme';

const kSettledLabels: Record<ApdmBuildStep, string> = {
  [ApdmBuildStep.What]: '确定营销类型',
  [ApdmBuildStep.Who]: '确定目标客户',
  [ApdmBuildStep.When]: '确定活动时间',
  [ApdmBuildStep.Which]: '确定优惠',
  [ApdmBuildStep.Messages]: '确定文案',
  [ApdmBuildStep.Launch]: '启动活动',
};

function record(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

/**
 * One line of the build's timeline, kept where it happened: a lookup that
 * finished (`apdm_plan_progress`) or a step the user settled
 * (`apdm_plan_settled`).
 */
export const PlanTimelineLine = memo(
  ({ widget, data }: { widget: string; data: unknown }) => {
    const { rpx } = useResponsiveContext();
    const row = record(data);
    const settled = widget === 'apdm_plan_settled';
    const text = settled
      ? kSettledLabels[row?.step as ApdmBuildStep]
      : typeof row?.text === 'string'
      ? row.text
      : null;
    if (!text) return null;
    // The line the status showed while it ran, ticked once it is done.
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(4),
          paddingHorizontal: rpx(4),
        }}
      >
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          {text}
        </Typography.Text>
        <Check size={13} color={aiColors.green} strokeWidth={2.5} />
      </View>
    );
  },
);
